import { ReactNode } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { ChatIcon } from '../chat-icon/chat-icon';
import { useStyles } from './grid-wrapper.styles';

interface IGridWrapperProps {
    /** Header shown above chat icon */
    header?: string;
    /** Show the chat icon? */
    showChatIcon?: boolean;
    /** Children to show in this grid */
    children?: ReactNode | string;
}

const GridWrapper = ({ children, header, showChatIcon = true }: IGridWrapperProps): JSX.Element => {
    const classes = useStyles();
    return (
        <Grid item md={12} xs={12} className={classes.item}>
            {header && <GridWrapperHeader>{header}</GridWrapperHeader>}
            {showChatIcon && <ChatIcon />}
            {children}
        </Grid>
    );
};

interface IHeader {
    children: string;
}

const GridWrapperHeader = ({ children }: IHeader): JSX.Element => {
    const classes = useStyles();
    return (
        <Typography variant="h1" color="textPrimary" className={classes.h1}>
            {children}
        </Typography>
    );
};

export { GridWrapper };
export type { IGridWrapperProps as IProps };
